const STATE_KEYS = {
  APPS: 'apps',
  GROUPS: 'groups',
  DISABLED_APPS: 'disabledApps',
  ACTIVE_ROUTE: 'activeRoute',
  ACTIVE_ROUTE_PARAMS: 'activeRouteParams',
  IFRAME_STATES: 'iFrameStates',
  LD_FLAGS: 'LDFlags',
  LOCALE: 'locale',
};

const state = {
  [STATE_KEYS.APPS]: {},
  [STATE_KEYS.GROUPS]: {},
  [STATE_KEYS.DISABLED_APPS]: false,
  [STATE_KEYS.ACTIVE_ROUTE]: null,
  [STATE_KEYS.ACTIVE_ROUTE_PARAMS]: null,
  [STATE_KEYS.IFRAME_STATES]: {},
  [STATE_KEYS.LD_FLAGS]: {},
  [STATE_KEYS.LOCALE]: 'en-US',
};

export {
  state,
  STATE_KEYS,
};
